module.exports = __webpack_public_path__ + "static/media/arrow.b423d005.svg";